<template>
  <div class="cap-center">
        <p class="feedback" v-if="feedback">{{ feedback }}</p>
        <div class="preload-spinner preload-small border-highlight" v-else></div>
    </div>
</template>

<script>
export default {
    name: 'Preloader',
    props: ['feedback']
}
</script>

<style>

</style>